import SelectorCondenser from './SelectorCondenser';

export default SelectorCondenser;
